// Anything layered above a dropdown: the shared confirmation modal, a
// PrimeVue dialog, or a toast.
const OVERLAY_SELECTOR = '.confirm-container, .p-dialog, .p-confirmdialog, .p-toast'

export default {
    methods: {
        /**
         * Whether the click landed inside something layered above the
         * dropdown, which v-click-outside would otherwise treat as an
         * outside click and close it.
         *
         * Matches on ancestry rather than the target's own class: a click
         * usually lands on a button or a line of text inside the overlay,
         * neither of which carries the overlay's own class.
         *
         * @param {Event} event
         * @returns {boolean}
         */
        hasBlockingClass(event) {
            return !!event.target?.closest?.(OVERLAY_SELECTOR)
        },
    },
}
